import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, ReplaySubject } from 'rxjs';
import { concatMap, map, take } from 'rxjs/operators';
import { EmployeeProfileService } from './employee-profile.service';
import { ApiCreds } from '../models';
import { tipsFormsDisplayUrl } from './constants';
import { rawBooleanResponse, booleanResponse } from '../models/generic-single-response.interface';
import * as utils from './utils/service.utils';

@Injectable({ providedIn: 'root' })
export class TipsFormsDisplayService {
  tipsFormsDisplaySubject = new ReplaySubject<boolean>(1);
  tipsFormsDisplay$ = this.tipsFormsDisplaySubject.asObservable();

  constructor(private employeeProfileService: EmployeeProfileService, private http: HttpClient) {
    this.displayTipsForms();
  }

  /* Fetch Data from API using Employee API Credentials */
  private fetchData(apiCreds: ApiCreds): Observable<rawBooleanResponse> {
    //1. Build URL string
    const url = `${tipsFormsDisplayUrl}/${apiCreds.bcl}/${apiCreds.id}`;

    //2. Fetch URL string and create Observable with Data.
    return this.http.get<rawBooleanResponse>(url);
  }

  private fetchTipsFormsDisplay(): Observable<boolean> {
    //1. Collect Employee Api Credentials from Profile Service.
    return this.employeeProfileService.apiCreds$.pipe(
      take(1),
      //2. concatMap to allow inner Observable & fetch Data with apiCreds
      concatMap(apiCreds => this.fetchData(apiCreds)),
      map(tipsFormsRawData => this.formatTipsForms(tipsFormsRawData))
    );
  }

  private formatTipsForms(tipsFormsRawData: rawBooleanResponse): boolean {
    const { Success, ErrorMessage, ...BooleanResponse } = tipsFormsRawData;

    // Do Stuff (like Toast message or Logging) if Success is False and ErrorMessage is NOT empty.
    const tipsFormsDisplay = utils.keysToCamelCase(BooleanResponse);

    return tipsFormsDisplay.result;
  }

  displayTipsForms(): void {
    //
    this.fetchTipsFormsDisplay().subscribe(displayTipForms =>
      this.tipsFormsDisplaySubject.next(displayTipForms)
    );
  }
}
